import { useState } from "react";
import { Alert, Button, Checkbox, Divider, Stack, TextField, Typography } from "@mui/material";
import { Delete, Save } from "@mui/icons-material";

export default function SessionForm({session, chapters, onSave, onDelete}){

    const [data, setData] = useState(session)

    const program = data.program || {}

    const isInProgram = chapterId => chapterId in program

    const toggleChapter = chapterId => {

        const next = {...program}

        if(isInProgram(chapterId)) delete next[chapterId]
        else next[chapterId] = null

        setData({...data, program: next})
    }

    const setUnlockAt = (chapterId, value) => setData({
        ...data,
        program: {...program, [chapterId]: value || null}
    })

    return <Stack spacing={2}>

        <Stack direction='row' spacing={2} flexWrap='wrap' useFlexGap>

            <TextField
                label="Intitulé"
                value={data.title || ''}
                onChange={e => setData({...data, title: e.target.value})}
                required
                size='small'
                sx={{flex: 1, minWidth: 220}}
            />

            <TextField
                label="Début"
                type='date'
                value={data.start || ''}
                onChange={e => setData({...data, start: e.target.value})}
                required
                size='small'
                InputLabelProps={{shrink: true}}
            />

            <TextField
                label="Fin"
                type='date'
                value={data.end || ''}
                onChange={e => setData({...data, end: e.target.value})}
                size='small'
                InputLabelProps={{shrink: true}}
            />

        </Stack>

        <Typography variant='caption' color='text.secondary'>
            La date de début ouvre l'accès à la formation. Avant ce jour, les
            apprenants de la session ne peuvent pas consulter le contenu. Les
            dates du programme commandent ensuite l'ouverture de chaque chapitre.
        </Typography>

        <Divider />

        <Typography variant='subtitle2'>Programme</Typography>

        {Object.keys(program).length === 0 &&
            <Alert severity='info'>
                Aucun chapitre coché : les apprenants de cette session voient
                toute la formation, sans déblocage progressif.
            </Alert>
        }

        {chapters.map(c =>

            <Stack key={c.id} direction='row' spacing={2} alignItems='center'>

                <Checkbox
                    checked={isInProgram(c.id)}
                    onChange={() => toggleChapter(c.id)}
                    size='small'
                />

                <Typography sx={{flex: 1}} color={isInProgram(c.id) ? 'text.primary' : 'text.disabled'}>
                    {c.title}
                </Typography>

                {isInProgram(c.id) &&
                    <TextField
                        label="Accessible à partir du"
                        type='date'
                        value={program[c.id] || ''}
                        onChange={e => setUnlockAt(c.id, e.target.value)}
                        size='small'
                        helperText={program[c.id] ? ' ' : 'Ouvert dès le début de la session'}
                        InputLabelProps={{shrink: true}}
                        sx={{width: 220}}
                    />
                }

            </Stack>
        )}

        <Divider />

        <Stack direction='row' spacing={2}>

            <Button startIcon={<Save />} onClick={() => onSave(data)} variant='contained'>
                Enregistrer
            </Button>

            <Button startIcon={<Delete />} color='error' onClick={onDelete}>
                Supprimer
            </Button>

        </Stack>

    </Stack>
}
